// CSS Modules - component class name prefix: Modal__

<template>
  <div :class="[$style.container, 'modal', { 'is-active': modalActive }]">
    <div class="modal-background" @click="internallyCloseModal"></div>
    <div :class="['modal-content', { [$style.product]: isProduct }]">
      <div
        ref="modalContent"
        :class="[
          $style.content,
          {
            [$style.video]: isVideo,
            [$style.notYouTube]: isVideo && isNotYouTube
          }
        ]"
      >
        <slot></slot>
        <div
          v-if="isVideo && !isNotYouTube && !consentGiven"
          :class="$style.consent"
        >
          <h2>{{ dictionary.consentHeading }}</h2>
          <div v-html="dictionary.consentText"></div>
          <Button
            isClose
            :class="$style.consentButton"
            :text="dictionary.consentButtonLabel"
            @close="handleContentButton"
          />
        </div>
      </div>
    </div>
    <button
      class="modal-close is-large"
      aria-label="close"
      @click="internallyCloseModal"
    ></button>
  </div>
</template>

<script>
import Button from "../Button/Button.vue";

export default {
  name: "Modal",
  components: {
    Button
  },
  props: {
    isModalOpen: {
      type: Boolean,
      default: false
    },
    isVideo: {
      type: Boolean,
      default: false
    },
    isNotYouTube: {
      type: Boolean,
      default: false
    },
    isProduct: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      modalActive: false,
      htmlElement: null,
      dictionary: window.dictionary,
      consentGiven: window.Cookiebot.consent.marketing
    };
  },
  methods: {
    handleContentButton() {
      window.Cookiebot.onaccept = () => {
        this.consentGiven = window.Cookiebot.consent.marketing;
        this.checkConsent();
      };
      window.Cookiebot.show();
    },
    checkConsent() {
      const iframe = this.$refs.modalContent.querySelector("iframe");

      if (iframe && this.isVideo) {
        if (this.consentGiven && this.modalActive) {
          if (!iframe.src) {
            iframe.src = iframe.getAttribute("data-src");
            iframe.removeAttribute("data-src");
          }
        } else {
          if (iframe.src) {
            iframe.setAttribute("data-src", iframe.src);
            iframe.removeAttribute("src");
          }
        }
      }
    },
    openModal() {
      this.modalActive = true;
      this.htmlElement.classList.add("is-clipped");
    },
    closeModal() {
      this.modalActive = false;
      this.htmlElement.classList.remove("is-clipped");
      if (this.isVideo && !this.isNotYouTube) {
        this.$refs.modalContent
          .querySelector("iframe")
          .contentWindow.postMessage(
            '{"event":"command","func":"stopVideo","args":""}',
            "*"
          );
      }
    },
    internallyCloseModal() {
      this.closeModal();
      this.$emit("closeModal");
    },
    escCloseModal(event) {
      if (event.keyCode === 27) {
        this.internallyCloseModal();
      }
    }
  },
  watch: {
    isModalOpen: function(newValue, oldValue) {
      if (newValue !== oldValue) {
        newValue === true ? this.openModal() : this.closeModal();
      }
    },
    modalActive: function() {
      this.consentGiven = window.Cookiebot.consent.marketing;
      window.setTimeout(this.checkConsent, 20);
    }
  },
  mounted() {
    window.addEventListener("keyup", this.escCloseModal);
    this.htmlElement = document.querySelector("html");
  },
  destroyed() {
    window.removeEventListener("keyup", this.escCloseModal);
  }
};
</script>

<style module lang="scss">
@import "./Modal.scss";
</style>
